import type { IxcPaymentsV1WireKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PAYMENTS_WIRE_BASE_PATH = getResolvedPath('/clearing/finance/payment/wire');

export const getPaymentsWirePath: EntityPathBuilder<IxcPaymentsV1WireKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PAYMENTS_WIRE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.wireId) {
        return undefined;
      }

      return getResolvedPath(`${PAYMENTS_WIRE_BASE_PATH}/$wireId`, context.keys);
    }
  }
};

export function getPaymentsWireDetailPath(wireId: string | undefined) {
  if (!wireId) {
    return undefined;
  }

  return getPaymentsWirePath({ kind: 'detail', keys: { wireId } });
}
